<script lang="ts">
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useAppStore } from '@/dashboard/store/appStore';
import { useSettingsStore } from '@/dashboard/store/settingsStore';

export default {
  beforeRouteEnter: async function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    const appStore = useAppStore();
    const settingsStore = useSettingsStore();

    await settingsStore.initPaddle();
    await appStore.loadCurrentUser();
    const user = appStore.currentUser;

    if (user) {
      await settingsStore.setSettingsUserModel(user);
    }

    next((vm) => {
      if (to.hash) {
        const element = vm.$el.querySelector(to.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  },
};
</script>

<script setup lang="ts">
import SettingsAvaSection from '@/dashboard/vue/components/settings/SettingsAvaSection.vue';
import SettingsFormSection from '@/dashboard/vue/components/settings/SettingsFormSection.vue';
import SettingsSavePanel from '@/dashboard/vue/components/settings/SettingsSavePanel.vue';
import SettingsDeleteUserSection from '@/dashboard/vue/components/settings/SettingsDeleteUserSection.vue';
import DeleteAccountPopup from '@/dashboard/vue/popups/DeleteAccountPopup.vue';
import SettingsWorspacesSection from '@/dashboard/vue/components/settings/SettingsWorspacesSection.vue';
</script>

<template>
  <div class="flex-1 px-xs pt-[56px] laptop:pt-[95px]">
    <div class="mx-auto flex max-w-[1197px] flex-col gap-y-s pb-[56px]">
      <SettingsAvaSection />
      <SettingsFormSection />
      <div id="workspaces">
        <SettingsWorspacesSection />
      </div>
      <SettingsDeleteUserSection />
    </div>

    <SettingsSavePanel />
    <DeleteAccountPopup />
  </div>
</template>
